export default "__VITE_ASSET__Z8XBU72V__"